<template>
  <div
    class="effect-wrapper"
  >
    <Drumroll v-if="mode.drum" :close="close" />
    <Confetti v-if="mode.confetti" :close="close" />
    <HandClap v-if="mode.hand" :close="close" />
  </div>
</template>
<script>
import Drumroll from '@/components-v2/presentation-editor/middle/effects/Drumroll.vue'
import Confetti from '@/components-v2/presentation-editor/middle/effects/Confetti.vue'
import HandClap from '@/components-v2/presentation-editor/middle/effects/HandClap.vue'

export default {
  components: {
    Confetti,
    Drumroll,
    HandClap,
  },
  props: {
    mode: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {

    }
  },
  watch: {
    '$store.state.slideActive': function slideActiveChangeWatcher() {
      this.close()
    },
    '$store.getters.isPresenting': function isPresentingWatcher(isPresenting) {
      if (!isPresenting) this.close()
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('hideEffectWrapper')
    },
  },
}
</script>
<style scoped lang='scss'>
.effect-wrapper {
  @apply flex items-center justify-center flex-col;
  @apply fixed top-0 right-0 h-full w-full;
  z-index: 150;
  pointer-events: none;
}
</style>
